import apiClient from './client';

export interface OAuthClientSummary {
  id: string;
  clientId: string;
  name: string;
  redirectUris: string[];
  origin: 'dynamic' | 'user';
  createdAt: string;
}

export interface IssuedOAuthClient extends OAuthClientSummary {
  clientSecret: string;
}

export interface ConsentInput {
  client_id: string;
  redirect_uri: string;
  code_challenge?: string;
  code_challenge_method?: 'S256' | 'plain';
  state?: string;
  scope?: string;
}

export const oauthApi = {
  listClients: async (): Promise<OAuthClientSummary[]> => {
    const { data } = await apiClient.get<OAuthClientSummary[]>('/oauth/clients');
    return data;
  },
  createClient: async (name: string, redirectUris: string[]): Promise<IssuedOAuthClient> => {
    const { data } = await apiClient.post<IssuedOAuthClient>('/oauth/clients', {
      name,
      redirectUris,
    });
    return data;
  },
  deleteClient: async (id: string): Promise<void> => {
    await apiClient.delete(`/oauth/clients/${id}`);
  },
  consent: async (input: ConsentInput): Promise<{ redirectUrl: string }> => {
    const { data } = await apiClient.post<{ redirectUrl: string }>('/oauth/consent', input);
    return data;
  },
};

export default oauthApi;
